export const events = [
  {
    id: "coffee-ingredient-swap",
    title: "新锐咖啡品牌「鹿野咖啡」原料替换风波：从后厨爆料到监管介入",
    category: "消费观察",
    categorySlug: "consumer",
    summary:
      "一名自称前员工的用户发布门店后厨视频，称部分门店将鲜奶替换为复原乳且未在菜单标注。事件在 60 小时内经历了首发爆料、品牌否认、内部聊天记录流出引发反转，最终以监管部门到店抽检收尾。",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20magazine%20illustration%20of%20a%20coffee%20cup%20and%20a%20torn%20ingredient%20label%20on%20a%20warm%20cream%20paper%20background%20with%20subtle%20grain%2C%20abstract%20geometric%20shards%2C%20deep%20vermilion%20and%20amber%20accents%2C%20soft%20directional%20light%2C%20minimal%20investigative%20newsroom%20aesthetic%2C%20high%20detail&width=1200&height=900&seq=scoop-coffee-01&orientation=landscape",
    tags: ["食品安全", "消费维权", "企业回应", "监管抽检"],
    heat: 98600,
    comments: 2417,
    publishTime: "2026-09-06 09:20",
    updateTime: "2026-09-08 21:40",
    source: "独家爆料编辑部",
    featured: true,
    timeline: [
      {
        time: "09-06 09:20",
        title: "首发爆料",
        desc: "匿名账号发布 1 分 48 秒后厨视频，画面中出现标注为「调制乳」的纸箱，并称该品牌三家门店长期使用替代原料。",
        type: "start",
      },
      {
        time: "09-06 14:05",
        title: "品牌首次回应",
        desc: "品牌方发布声明，称爆料者系因考核不合格被辞退，视频存在剪辑，并否认存在原料替换行为。",
        type: "update",
      },
      {
        time: "09-07 10:30",
        title: "关键反转",
        desc: "另一名在职员工提供内部采购群聊天记录，显示区域仓配确实在 4 月起更换供应批次，与品牌声明的口径存在冲突。",
        type: "reversal",
      },
      {
        time: "09-07 19:15",
        title: "平台下架相关套餐",
        desc: "外卖平台将该品牌的「鲜奶系列」套餐标注为「信息核实中」，并暂时关闭相关商品评价入口。",
        type: "followup",
      },
      {
        time: "09-08 11:00",
        title: "监管部门到店抽检",
        desc: "辖区市场监管部门对涉事三家门店进行现场抽检，封存原料样品，表示结果将在 7 个工作日内公示。",
        type: "followup",
      },
      {
        time: "09-08 21:40",
        title: "最新进展",
        desc: "品牌方第二次致歉，承认部分门店「存在原料标注不完整」，承诺对 8 月 1 日以来购买相关产品的用户开放退款通道。",
        type: "update",
      },
    ],
    body: [
      "这场风波之所以能在短时间内冲上热榜，核心并不在于原料本身，而在于「菜单上写的是什么」与「杯子里装的是什么」之间是否一致。消费者愿意为「鲜奶」支付溢价，本质上是为一份明确、可验证的承诺买单。",
      "首发爆料的角度相当克制：视频没有直接指控食品安全问题，而是把焦点对准了标签。这一点在后来的讨论中被反复引用——爆料者的主张并不是「饮品不能喝」，而是「标注与实际不符」。",
      "品牌方第一次回应的速度不慢，但把叙事重心放在了爆料者的身份上。这种回应方式在舆论场里往往效果有限，因为它没有直接回答最关键的问题：供应批次是否发生过变化。当第二天下午内部采购群的截图流出后，原本已经降温的话题迅速二次升温，形成了本次事件最主要的一次反转。",
      "值得注意的是，本次事件中出现了一个中间变量：平台。平台在商品页加注「信息核实中」，实际上把原本属于品牌与消费者之间的争议，拉进了一个更公开的评判场景，也让品牌方在处理退款与公关节奏时不得不考虑平台的规则约束。",
      "目前监管抽检结果尚未公布，退款通道的细则也有待观察。我们会在结果出来后更新本文时间线，并补充对已购用户的实际影响评估。",
    ],
  },
  {
    id: "headline-streamer-gmv",
    title: "头部主播「带货数据注水」风波：第三方监测与后台截图的正面对撞",
    category: "网络热点",
    categorySlug: "internet",
    summary:
      "某场专场直播对外宣称成交额破亿，随后第三方监测机构给出相差数倍的数据。双方各自晒出证据，事件从数据之争演变为对行业口径的集体讨论。",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20magazine%20illustration%20of%20a%20studio%20microphone%20and%20a%20rising%20bar%20chart%20on%20a%20warm%20cream%20paper%20background%20with%20subtle%20grain%2C%20abstract%20geometric%20blocks%2C%20deep%20vermilion%20and%20amber%20accents%2C%20soft%20directional%20light%2C%20minimal%20investigative%20newsroom%20aesthetic%2C%20high%20detail&width=1200&height=900&seq=scoop-live-02&orientation=landscape",
    tags: ["直播带货", "数据口径", "行业标准", "反转"],
    heat: 87300,
    comments: 1892,
    publishTime: "2026-09-02 20:10",
    updateTime: "2026-09-05 16:20",
    source: "独家爆料编辑部",
    timeline: [
      {
        time: "09-02 20:10",
        title: "首发质疑",
        desc: "一家第三方监测机构发布对比图，称该场直播的公示成交额与实际支付口径相差约 4.7 倍。",
        type: "start",
      },
      {
        time: "09-03 09:45",
        title: "团队回应",
        desc: "主播团队晒出后台交易截图，强调数据包含预售尾款，属于「合规口径」，并指责监测机构取样不完整。",
        type: "update",
      },
      {
        time: "09-04 15:30",
        title: "机构补充证据",
        desc: "监测机构公布抓取日志与时间戳，指出预售尾款在统计窗口结束后才产生，不应计入当场成交。",
        type: "reversal",
      },
      {
        time: "09-05 16:20",
        title: "平台调整规则",
        desc: "平台宣布自下月起要求直播间在公示成交额时同步标注统计口径，避免同类争议。",
        type: "followup",
      },
    ],
    body: [
      "这场争论看起来是两组数字的碰撞，实际上暴露的是「成交额」缺少统一口径的问题。同一场直播，按不同统计方式可以得出差异巨大的结果，而观众看到的往往只是一个被放大的数字。",
      "团队晒出后台截图的做法在情绪层面是有效的，它让支持者有了「实锤」的观感。但截图本身并不能说明统计窗口的选择是否合理，这也是第二天监测机构给出抓取日志后，舆论迅速转向的原因。",
      "更值得关注的是第三方的处理方式。平台没有站队，而是直接把争议转化为规则调整，要求标注统计口径。对行业来说，这可能是本次风波里真正留下痕迹的一个后续。",
      "对于我们这些围观者来说，一个实用的建议是：看到任何「破亿」数字时，先找口径说明，再看时间窗口。数字本身不难查，难的是它背后被省略了哪些限定条件。",
    ],
  },
  {
    id: "ai-model-data",
    title: "国产大模型「训练数据来源」争议：一份内部文档引出的行业追问",
    category: "科技前线",
    categorySlug: "tech",
    summary:
      "一份标注为内部会议纪要的文档在技术社区流传，涉及某大模型的数据采集边界。团队回应后，文档的真实性与其反映的流程问题成为新的焦点。",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20magazine%20illustration%20of%20a%20neural%20network%20node%20diagram%20and%20flowing%20data%20lines%20on%20a%20warm%20cream%20paper%20background%20with%20subtle%20grain%2C%20abstract%20geometric%20shapes%2C%20deep%20vermilion%20and%20amber%20accents%2C%20soft%20directional%20light%2C%20minimal%20investigative%20newsroom%20aesthetic%2C%20high%20detail&width=1200&height=900&seq=scoop-ai-03&orientation=landscape",
    tags: ["大模型", "数据合规", "技术社区", "后续追踪"],
    heat: 64200,
    comments: 1130,
    publishTime: "2026-08-29 11:30",
    updateTime: "2026-09-04 09:10",
    source: "独家爆料编辑部",
    timeline: [
      {
        time: "08-29 11:30",
        title: "文档流出",
        desc: "技术社区出现一份标注为内部会议纪要的文档，提及数据采集的边界讨论与质检流程。",
        type: "start",
      },
      {
        time: "08-30 18:00",
        title: "团队回应",
        desc: "模型团队表示文档「经过拼接」，强调数据来源符合规范，但未逐条说明文档中的流程描述是否属实。",
        type: "update",
      },
      {
        time: "09-01 14:20",
        title: "质疑升级",
        desc: "多名从业者指出，文档中提到的质检环节在同类团队中普遍存在，争论焦点从真伪转向流程规范。",
        type: "reversal",
      },
      {
        time: "09-04 09:10",
        title: "行业倡议",
        desc: "多家技术社区联合发起数据来源透明化倡议，建议公开训练数据的采集与过滤说明。",
        type: "followup",
      },
    ],
    body: [
      "技术圈对这类文档并不陌生：它通常不是决定性证据，却能精准戳中行业长期回避的问题。本次流出的文档之所以被广泛讨论，是因为它描述的不是某一次越界，而是一套可能被默认接受的流程。",
      "团队的回应选择了「否认文档完整性」这一路径，这在法律层面是稳妥的，但在技术讨论层面留下了空白。因为即便文档被拼接，其中提到的质检环节是否真实存在，仍然是可以被验证的问题。",
      "第三天之后，讨论的重心明显发生了变化。越来越多的从业者不再追究文档来源，而是转而讨论「什么样的数据采集流程才算是规范」。这种转向让事件的影响力从一个团队扩展到了整个行业。",
      "目前，多家技术社区发起的透明度倡议仍在征集签名。我们会持续跟进是否有关键团队公开表态。",
    ],
  },
  {
    id: "drama-recast",
    title: "热播剧中途「换角」内幕：制作方、演员与平台的三方说法",
    category: "娱乐圈",
    categorySlug: "entertainment",
    summary:
      "一部开播后口碑上升的剧集突然宣布更换男主，官方理由是档期冲突。随后多方先后放出消息，说法彼此矛盾，事件陷入罗生门。",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20magazine%20illustration%20of%20a%20theatre%20spotlight%20and%20a%20folded%20script%20on%20a%20warm%20cream%20paper%20background%20with%20subtle%20grain%2C%20abstract%20geometric%20frames%2C%20deep%20vermilion%20and%20amber%20accents%2C%20soft%20directional%20light%2C%20minimal%20investigative%20newsroom%20aesthetic%2C%20high%20detail&width=1200&height=900&seq=scoop-drama-04&orientation=landscape",
    tags: ["剧集", "换角", "多方回应", "罗生门"],
    heat: 79500,
    comments: 3064,
    publishTime: "2026-08-26 10:00",
    updateTime: "2026-09-01 20:45",
    source: "独家爆料编辑部",
    timeline: [
      {
        time: "08-26 10:00",
        title: "官宣换角",
        desc: "剧方发布通告，称因档期原因更换主要演员，已拍摄部分将进行补拍。",
        type: "start",
      },
      {
        time: "08-27 13:20",
        title: "艺人方回应",
        desc: "原演员工作室称「从未收到档期冲突的通知」，并表示对换角决定感到意外。",
        type: "update",
      },
      {
        time: "08-29 16:40",
        title: "剧组人员爆料",
        desc: "自称剧组工作人员的用户称，分歧源于剧本大幅修改，与档期关系不大，形成关键反转。",
        type: "reversal",
      },
      {
        time: "09-01 20:45",
        title: "平台表态",
        desc: "播出平台表示尊重制作方决定，补拍进度将直接影响后续集数排播，并承诺不删减已完成剧情。",
        type: "followup",
      },
    ],
    body: [
      "娱乐圈的换角并不罕见，但「开播后换角」相对少见，因为它意味着已经播出的内容与后续观众认知将出现断裂。这也是本次事件从行业新闻变成公共话题的原因。",
      "三方回应的时间线很有意思：制作方最先发声且口径具体，艺人方隔天回应但措辞克制，剧组人员的爆料在第三天出现。信息越靠后出现，情绪浓度反而越高，这是舆论场常见的规律。",
      "从观众的角度，最直接的关切其实很朴素：已播出的剧情会不会被改，补拍之后角色的连贯性还能不能保证。平台在最后一天的回应中，算是正面回答了这个问题。",
      "补拍尚未完成，实际效果需要等后续集数上线才能评判。我们会把播出后的观众反馈补充到时间线里。",
    ],
  },
  {
    id: "gym-closing",
    title: "连锁健身品牌「闭店前兆」爆料合集：会员、教练与房东的不同视角",
    category: "消费观察",
    categorySlug: "consumer",
    summary:
      "多地门店出现停课、退费拖延等情况，会员自发整理的爆料表格在社交平台流传。教练与房东的说法，为「是否闭店」提供了补充视角。",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20magazine%20illustration%20of%20a%20dumbbell%20and%20a%20closed%20padlock%20on%20a%20warm%20cream%20paper%20background%20with%20subtle%20grain%2C%20abstract%20geometric%20blocks%2C%20deep%20vermilion%20and%20amber%20accents%2C%20soft%20directional%20light%2C%20minimal%20investigative%20newsroom%20aesthetic%2C%20high%20detail&width=1200&height=900&seq=scoop-gym-05&orientation=landscape",
    tags: ["预付卡", "退费", "消费者", "后续追踪"],
    heat: 52100,
    comments: 876,
    publishTime: "2026-08-21 08:50",
    updateTime: "2026-08-28 17:30",
    source: "独家爆料编辑部",
    timeline: [
      {
        time: "08-21 08:50",
        title: "会员爆料",
        desc: "多地会员在社交平台反映门店突然停课、私教无法预约，退费申请长时间未处理。",
        type: "start",
      },
      {
        time: "08-23 11:15",
        title: "教练发声",
        desc: "数名教练称已被拖欠两个月薪资，并透露门店正在调整租约，引发对闭店的担忧。",
        type: "update",
      },
      {
        time: "08-25 15:00",
        title: "品牌回应",
        desc: "品牌方称这是「校区优化」而非闭店，承诺分批次处理退费，但未给出明确时间表。",
        type: "update",
      },
      {
        time: "08-28 17:30",
        title: "监管介入",
        desc: "消协约谈品牌方，要求就预付费退费方案作出书面说明，首批退费名单开始公示。",
        type: "followup",
      },
    ],
    body: [
      "预付制消费的风险在这次事件中体现得相当典型：用户提前支付了长期费用，却无法控制履约方的经营变化。一旦门店调整，退费就变成了漫长的沟通。",
      "会员自发整理的爆料表格值得单独一提。这次不是单一账号爆料，而是数十名用户把各自的合同、沟通记录按时间整理成表，客观上让事件的事实基础变得扎实，也让品牌方难以用「个别情况」概括。",
      "教练群体提供的信息补上了关键一角。他们既是知情者，也是受影响的一方，其关于租约调整的说法，比会员的推测更接近经营层面的真实原因。",
      "目前首批退费名单已经公示，但覆盖比例有限。我们会持续关注后续批次的处理进度。",
    ],
  },
  {
    id: "ev-range-claim",
    title: "新能源车企「续航虚标」集体爆料：低温实测数据为何差异巨大",
    category: "商业内幕",
    categorySlug: "business",
    summary:
      "一批车主在同一时间集中发布冬季实测数据，与官方标称续航存在明显差距。测试方法、温度区间与驾驶习惯的差异，成为争议核心。",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20magazine%20illustration%20of%20an%20electric%20car%20silhouette%20and%20a%20battery%20gauge%20on%20a%20warm%20cream%20paper%20background%20with%20subtle%20grain%2C%20abstract%20geometric%20shapes%2C%20deep%20vermilion%20and%20amber%20accents%2C%20soft%20directional%20light%2C%20minimal%20investigative%20newsroom%20aesthetic%2C%20high%20detail&width=1200&height=900&seq=scoop-ev-06&orientation=landscape",
    tags: ["新能源", "续航测试", "标准口径", "车主实测"],
    heat: 61300,
    comments: 1420,
    publishTime: "2026-08-17 07:40",
    updateTime: "2026-08-24 19:05",
    source: "独家爆料编辑部",
    timeline: [
      {
        time: "08-17 07:40",
        title: "集中爆料",
        desc: "数十名车主在同一话题下发布冬季续航实测截图，多数显示实际续航低于标称值的六成。",
        type: "start",
      },
      {
        time: "08-19 14:00",
        title: "车企回应",
        desc: "品牌方强调标称续航基于统一测试标准，实际使用受温度、路况与空调影响，属正常范围。",
        type: "update",
      },
      {
        time: "08-21 10:20",
        title: "标准之争",
        desc: "有工程师指出争议根源在于测试标准与真实场景差距过大，呼吁补充低温工况公示。",
        type: "reversal",
      },
      {
        time: "08-24 19:05",
        title: "口径更新",
        desc: "品牌方在官网新增「低温续航参考值」栏目，标注不同温度区间的预期衰减比例。",
        type: "followup",
      },
    ],
    body: [
      "续航争议几乎是新能源行业每年冬季的保留议题，但这一次的讨论方式发生了变化：车主不再只晒单张截图，而是倾向于附上行驶里程、平均车速与环境温度，让数据具备了可比性。",
      "品牌方的回应在技术上是站得住脚的，标称值确实来自统一测试标准。问题在于，当消费者用完全不同的场景去理解这个数字时，沟通的成本就被推高到了使用说明书的层面。",
      "本次事件里最关键的一句话，来自一位工程师的评价：争议不是「谁在说谎」，而是「标准没有告诉用户，在什么条件下会打几折」。这句话让讨论从情绪回到了方法。",
      "品牌方最终新增的低温参考值栏目，可以视为一种务实回应。后续是否会有更多厂商跟进，值得持续观察。",
    ],
  },
  {
    id: "restaurant-kitchen",
    title: "网红餐厅「后厨整改」后续追踪：复检结果与消费者的真实评价",
    category: "社会现场",
    categorySlug: "society",
    summary:
      "此前被曝光的网红餐厅在整改后重新开业。复检结果公示、客流变化与真实评价，构成本次事件的完整后续。",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20magazine%20illustration%20of%20a%20stainless%20kitchen%20counter%20and%20an%20inspection%20checklist%20on%20a%20warm%20cream%20paper%20background%20with%20subtle%20grain%2C%20abstract%20geometric%20tiles%2C%20deep%20vermilion%20and%20amber%20accents%2C%20soft%20directional%20light%2C%20minimal%20investigative%20newsroom%20aesthetic%2C%20high%20detail&width=1200&height=900&seq=scoop-kitchen-07&orientation=landscape",
    tags: ["餐饮", "整改复检", "口碑", "后续"],
    heat: 43800,
    comments: 645,
    publishTime: "2026-08-12 16:00",
    updateTime: "2026-08-22 12:30",
    source: "独家爆料编辑部",
    timeline: [
      {
        time: "08-12 16:00",
        title: "停业整改",
        desc: "餐厅因后厨卫生问题被要求停业整改，相关负责人公开道歉并承诺改造流程。",
        type: "start",
      },
      {
        time: "08-17 10:00",
        title: "复检公示",
        desc: "监管部门公布复检结果，卫生指标合格，同时要求加装后厨实时显示设备。",
        type: "update",
      },
      {
        time: "08-20 12:00",
        title: "重新开业",
        desc: "餐厅重新营业，开放式厨房正式启用，首日客流较曝光前下降约四成。",
        type: "followup",
      },
      {
        time: "08-22 12:30",
        title: "口碑观察",
        desc: "平台评价出现分歧：肯定整改效果的用户与质疑「短期表演」的用户比例接近。",
        type: "followup",
      },
    ],
    body: [
      "餐饮品牌的危机后续往往比危机本身更能说明问题。本次事件中，最值得记录的不是道歉声明，而是重新开业之后的客流与评价变化。",
      "复检合格是必要程序，但它只能证明某个时间点的状态。真正决定口碑的是长期执行，这也是不少消费者持观望态度的原因——他们要看的不是一次抽检，而是半年后的状态。",
      "开放式厨房与实时显示设备的启用，把监督权部分交还给了顾客。这是一种成本不低但效果直接的整改方式，也让「整改」从纸面上的承诺变成了可以被看见的日常。",
      "我们会在三个月后回访这家餐厅，对比两次的评价分布，给出更完整的后续观察。",
    ],
  },
  {
    id: "shortvideo-algorithm",
    title: "短视频平台「推荐算法」内部邮件流出：流量分配规则被重新审视",
    category: "科技前线",
    categorySlug: "tech",
    summary:
      "一封据称来自平台内部的邮件在创作者群体中流传，内容涉及内容分发权重调整。平台回应后，创作者的实测数据成为验证材料。",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20magazine%20illustration%20of%20a%20smartphone%20screen%20and%20swirling%20flow%20arrows%20on%20a%20warm%20cream%20paper%20background%20with%20subtle%20grain%2C%20abstract%20geometric%20ribbons%2C%20deep%20vermilion%20and%20amber%20accents%2C%20soft%20directional%20light%2C%20minimal%20investigative%20newsroom%20aesthetic%2C%20high%20detail&width=1200&height=900&seq=scoop-algo-08&orientation=landscape",
    tags: ["算法", "创作者", "流量分配", "平台回应"],
    heat: 46900,
    comments: 732,
    publishTime: "2026-08-08 18:20",
    updateTime: "2026-08-15 09:50",
    source: "独家爆料编辑部",
    timeline: [
      {
        time: "08-08 18:20",
        title: "邮件流出",
        desc: "创作者社区出现一封内部邮件，提及将对中长视频的分发权重进行调整。",
        type: "start",
      },
      {
        time: "08-10 11:00",
        title: "平台回应",
        desc: "平台称邮件「不代表最终方案」，强调算法目标始终是用户体验，未确认具体调整。",
        type: "update",
      },
      {
        time: "08-13 20:10",
        title: "实测验证",
        desc: "多位创作者公布同期数据对比，显示中长视频完播率与推荐量确实出现同步变化。",
        type: "reversal",
      },
      {
        time: "08-15 09:50",
        title: "官方说明",
        desc: "平台发布创作者说明文档，首次公开部分流量分配原则，并开放规则更新通知订阅。",
        type: "followup",
      },
    ],
    body: [
      "算法不透明长期是创作者与平台之间的张力来源。这次事件提供了一个难得的观察窗口：当内部信息与外部实测数据同时出现时，平台不得不从「不予置评」转向「公开说明」。",
      "值得注意的是，本次最有说服力的材料并非那封邮件，而是创作者在邮件流出后进行的测数据对比。多位创作者在同一时间窗口内记录推荐量与完播率的变化，这种自发的横向验证，让讨论有了可核查的基础。",
      "平台最终发布的创作者说明文档，虽然仍有保留，但至少明确了部分分配原则，并开放了规则更新通知。对平台而言，这是被动回应；对创作者而言，这是可预期的进步。",
      "规则会继续变化，创作者与平台之间的博弈也不会结束。我们会持续更新这份时间线。",
    ],
  },
];

export const categories = [
  { slug: "consumer", name: "消费观察", desc: "紧盯预付、退费、售后与标注争议", count: 128, icon: "ri-shopping-bag-3-line" },
  { slug: "internet", name: "网络热点", desc: "热搜背后的来龙去脉与舆论反转", count: 214, icon: "ri-fire-line" },
  { slug: "tech", name: "科技前线", desc: "平台规则、算法与数据合规动态", count: 96, icon: "ri-cpu-line" },
  { slug: "entertainment", name: "娱乐圈", desc: "剧集、综艺与艺人相关事件的追踪", count: 173, icon: "ri-movie-2-line" },
  { slug: "business", name: "商业内幕", desc: "企业经营、标准口径与行业内情", count: 87, icon: "ri-line-chart-line" },
  { slug: "society", name: "社会现场", desc: "公共事件的过程还原与后续回访", count: 141, icon: "ri-building-2-line" },
];

export const latestUpdates = [
  { time: "09-08 21:40", text: "鹿野咖啡二次致歉，承认部分门店原料标注不完整" },
  { time: "09-08 11:00", text: "监管部门对鹿野咖啡三家门店现场抽检，原料样品已封存" },
  { time: "09-05 16:20", text: "平台要求直播间公示成交额须同步标注统计口径" },
  { time: "09-04 09:10", text: "多家技术社区联合发起训练数据来源透明化倡议" },
  { time: "09-01 20:45", text: "播出平台回应换角：补拍进度将影响后续集数排播" },
  { time: "08-28 17:30", text: "消协约谈健身品牌，首批预付费退费名单开始公示" },
  { time: "08-24 19:05", text: "车企官网新增低温续航参考值栏目" },
  { time: "08-22 12:30", text: "网红餐厅整改后评价分化，观望用户比例接近一半" },
];